import {IonButton, IonButtons, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonInfiniteScroll, IonInfiniteScrollContent, IonLabel, IonList, IonMenuButton, IonNote, IonPage, IonRefresher, IonRefresherContent, IonRouterLink, IonRow, IonSegment, IonSegmentButton, IonTitle, IonToolbar, RefresherEventDetail, useIonModal, useIonRouter, useIonViewWillEnter, useIonViewWillLeave} from '@ionic/react';
import {capitalize, productInfo} from '../utils';
import {useStoreState} from 'pullstate';

import {getPageData, getQuotes} from "../store/Selectors";
import React, {Fragment, useEffect, useRef, useState} from "react";
import {QuoteItem} from "../components/QuoteItem";
import {ContractItem} from "../components/ContractItem";
import {fetch_pg_1_2} from "../store/Pg_1_Store";
import {checkmarkOutline, chevronDownCircleOutline} from "ionicons/icons";
import {TokenStackItem} from "../components/TokenStackItem";
import {useAppUtil, useSideMenuOptions, useSideMenuUpdate} from "../components/sideMenu/SideMenuProvider";
import {tab1SideMenu} from "../components/sideMenu/PageSideMenus";
import {PageHeader} from "./PageHeader";
import {Modal} from "./Modal";
import CustomPage from "./CustomPage";
import {TokenEnwItem} from "../components/TokenEnwItem";
import {TokenEnwEntrustListItem} from "../components/TokenEnwEntrustListItem";
import {useParams} from "react-router";
import {useLoginFields} from "./Pg_A_1";
import {validateForm} from "../_/useForms";
import indexBy from "underscore/modules/indexBy";
import styles_TokenItem from "../components/CheckableTokenItem.module.scss";
import {handleFetchCommonErrors, navAwayToPg_2_1, navAwayToPg_6_1, navAwayToPg_6_2, navAwayToPg_6_3, navAwayToPg_6_4} from "./Utils";
import {fetch_Pg_6_1, Pg_6_1_Store, push_pg_6_1__DeletePlaylist, push_pg_6_1__SetPlaylist} from "../store/Pg_6_Store";
import ClassNames from "../components/ClassNames";
import {CheckableTokenEnwItem} from "../components/CheckableTokenEnwItem";
import {PlaylistTokenEnwItem} from "../components/PlaylistTokenEnwItem";
import {AuthStore, UserTokenEnwStore} from "../store/Common_Store";
import {Modal_2_3_Transfer} from "./Modal_2_3_Transfer";
import {Modal_6_1_SetPlaylist} from "./Modal_6_1_SetPlaylist";
import {usePageDataLoader} from "../_/usePageDataLoader";
import {List} from "../components/drag/List";
import {horizontalListSortingStrategy} from "@dnd-kit/sortable";
import {Wrapper} from "../components/drag/Wrapper";

const Pg_6_1 = (props) => {
    const pageRef = useRef();
    const pageName = "Pg_6_1";
    const pageId = "Pg_6_1";
    const {sideMenuOptions} = props;
    const setSideMenu: any = useSideMenuUpdate();
    const sideMenu: any = useSideMenuOptions();

    const router = useIonRouter();

    ///會員
    const authStore = useStoreState(AuthStore, getPageData);
    const hasAuthed = authStore?.signBy ?? false;
    const Item_會員 = hasAuthed ? authStore?.AuthData : undefined;

    useEffect(() => {
        setSideMenu({options: sideMenuOptions, side: "start", pageName: pageId});
    }, []);

    // useIonViewWillEnter(() => {
    //     console.warn('useIonViewWillEnter 6_1')
    // });
    //
    // useIonViewWillLeave(() => {
    //     console.warn('useIonViewWillLeave 6_1')
    // });

    //#region Data Loading
    // useEffect(() => {
    //     console.warn('fetch_Pg_6_1 6_1');
    //
    //     (async () => {
    //         let errorObj = await fetch_Pg_6_1();
    //         handleFetchCommonErrors(router, errorObj);
    //     })();
    // }, []);


    const userTokenEnwStore = useStoreState(UserTokenEnwStore, getPageData);

    const pgData = useStoreState(Pg_6_1_Store, getPageData);

    let {pageDataLoaderCtrl} = usePageDataLoader('/tabs/6_1', Pg_6_1_Store, async () => {
        let errorObj = await fetch_Pg_6_1();
        handleFetchCommonErrors(router, errorObj);
    })

    let reload = async (event?: CustomEvent<RefresherEventDetail>) => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
        pageDataLoaderCtrl?.loadingFunc()
        event?.detail?.complete();
    }

    useEffect(() => {
        if (pgData?.reload == true) {
            Pg_6_1_Store.replace({});
            reload();
        }
    }, [pgData]);


    const hasLoaded = pgData?.Root ?? false;
    const List_撥放清單 = hasLoaded ? pgData.Root.List_撥放清單 : undefined;
    const RegionLockMessage = null//hasLoaded ? pgData.Root.RegionLockMessage : undefined;
    //#endregion


    //#region +Event

    const playlistIdRef = useRef<null | string>(null);

    const [presentWebModal_trasnfer, dismissWebModal_transfer] = useIonModal(Modal_6_1_SetPlaylist, {
        dismiss: () => dismissWebModal_transfer(),
        playlistIdRef: playlistIdRef,
        //set: (val) => setQRData(val),
        onResult: (result) => {
            //navAwayToPg_2_1(router);


            if (result) {
                //reload();
                alert('已傳送');
            }
        },
        //product: selectedProduct
    });
    const start_scanner = async (playlistId) => {
        // const platforms = getPlatforms();
        // const isWeb = (platforms.includes("desktop") || platforms.includes("mobileweb") || platforms.includes("pwa"));
        //
        // if (!isWeb) {
        //     const data = await BarcodeScanner.scan();
        //     if (data) {
        //         handleSuccess(data);
        //     }
        // } else {
        //     presentWebModal_trasnfer({
        //         presentingElement: pageRef.current
        //     });
        // }

        if (hasAuthed) {
            playlistIdRef.current = playlistId;
            presentWebModal_trasnfer({
                //cssClass: "product-modal",
                presentingElement: pageRef.current,
                initialBreakpoint: 0.95,
                breakpoints: [0, 0.25, 0.5, 0.75, 0.95],
            });
        } else {
            alert('遵循所在地法規，暫不開放移轉功能！');
        }
    }


    const _push_deletePlaylist = async (playlistId: any) => {
        if (!window.confirm('確定要刪除嗎')) {
            return;
        }

        let {errorObj, payload} = (await push_pg_6_1__DeletePlaylist({
            p1: playlistId,
        }));
        handleFetchCommonErrors(router, errorObj);
        if (!errorObj) {
            alert('已刪除');
            reload();
        } else {
        }
    }

    //#endregion

    const baseStyles: any = {
        height: 150,
        width: 150,
    };

    const listProps: any = {
        Container: (props: any) => <List horizontal {...props} />,
        itemCount: 1,
        getItemStyles: () => baseStyles,
        strategy: horizontalListSortingStrategy,
    };

    return (
        <IonPage id={pageId}>
            <CustomPage name={pageId} sideMenu={false} sideMenuPosition="start" backButton={false}>
                <IonRefresher slot="fixed" onIonRefresh={reload}>
                    <IonRefresherContent
                        pullingIcon={chevronDownCircleOutline}
                        pullingText="Pull to refresh"
                        refreshingSpinner="circles"
                        refreshingText="Refreshing...">
                    </IonRefresherContent>
                </IonRefresher>

                {hasLoaded && <Fragment>
                    {RegionLockMessage !== null ?
                        <>
                            <IonGrid>
                                <IonRow>
                                    <IonCol className="ion-justify-content-center ion-text-center w100 ion-padding">
                                        {RegionLockMessage}
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                        </> : <>
                            {/*<IonRouterLink routerLink={`/5_1`}>*/}
                            {/*    <IonButton fill={"solid"}>*/}
                            {/*        <IonIcon icon={checkmarkOutline}/>*/}
                            {/*        &nbsp;全部委託 跳到5_1*/}
                            {/*    </IonButton>*/}
                            {/*</IonRouterLink>*/}

                            {/*<IonRouterLink routerLink={`/5_5`}>*/}
                            {/*    <IonButton fill={"solid"}>*/}
                            {/*        <IonIcon icon={checkmarkOutline}/>*/}
                            {/*        &nbsp;我的委託 跳到5_5*/}
                            {/*    </IonButton>*/}
                            {/*</IonRouterLink>*/}

                            {/*<IonRouterLink routerLink={`/5_7`}>*/}
                            {/*    <IonButton fill={"solid"}>*/}
                            {/*        <IonIcon icon={checkmarkOutline}/>*/}
                            {/*        &nbsp;標記委託 跳到5_7*/}
                            {/*    </IonButton>*/}
                            {/*</IonRouterLink>*/}

                            <IonGrid className="ion-padding">
                                {/*<IonRow className={ styles.searchContainer }>*/}
                                {/*    <IonCol size="12">*/}
                                {/*        <IonSearchbar animated placeholder="Search for a product" />*/}
                                {/*    </IonCol>*/}
                                {/*</IonRow>*/}


                                {/*click={() => handleShowModal(item)}*/}

                                <IonButton className="custom-button" expand="block" onClick={r => {
                                    navAwayToPg_6_2(router);
                                }}>新增撥放清單</IonButton>
                            </IonGrid>


                            {List_撥放清單.map((Item_撥放清單, idx) => {
                                let key = Item_撥放清單.TokenEnwId組
                                    ?.split(",")
                                    ?.map(item => item.trim())
                                    ?.filter(Boolean) ?? [];

                                return <Fragment key={Item_撥放清單.撥放清單Id}>
                                    <IonGrid>
                                        <IonRow>
                                            <IonCol className={ClassNames("ion-justify-content-center ion-text-center w100 ion-padding", {
                                                    [styles_TokenItem.colorGrey]: idx % 2 == 0
                                                }
                                            )}>
                                                <div>{Item_撥放清單.撥放清單名稱}</div>
                                                <div>
                                                    <IonRow className="ion-margin-top">
                                                        <IonCol size="12">
                                                            <div className={ClassNames(styles_TokenItem.oneRowDiv)}>
                                                                <IonButton className="custom-button" expand="block" onClick={(e) => {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();

                                                                    start_scanner(Item_撥放清單.撥放清單Id);
                                                                }}>掃描投放</IonButton>

                                                                <IonButton className="custom-button" expand="block" onClick={r => {
                                                                    navAwayToPg_6_4(router, Item_撥放清單.撥放清單Id);
                                                                }}>畫牆產生器</IonButton>

                                                                <IonButton className="custom-button" expand="block" onClick={r => {
                                                                    navAwayToPg_6_3(router, Item_撥放清單.撥放清單Id);
                                                                }}>編輯清單</IonButton>

                                                                <IonButton className="custom-button" expand="block" onClick={r => {
                                                                    _push_deletePlaylist(Item_撥放清單.撥放清單Id);
                                                                }}>刪除清單</IonButton>
                                                            </div>
                                                        </IonCol>
                                                    </IonRow>
                                                </div>
                                                <IonRow className="ion-margin-top"><IonCol size="12">
                                                    <div className={ClassNames(styles_TokenItem.coverImageContainer, pageId)}>
                                                        <List>
                                                            <Wrapper center >
                                                                <div className={ClassNames(styles_TokenItem.oneRowDiv)}>
                                                                {key.map(k => {
                                                                    let Item_TokenEnw = userTokenEnwStore[k];
                                                                    return <Fragment key={Item_TokenEnw.TokenEnwId}>
                                                                        <PlaylistTokenEnwItem Item_TokenEnwItem={Item_TokenEnw}/>
                                                                    </Fragment>
                                                                })}
                                                                </div>
                                                            </Wrapper>
                                                        </List>
                                                    </div>
                                                </IonCol>
                                                </IonRow>
                                            </IonCol>
                                        </IonRow>
                                    </IonGrid>
                                </Fragment>
                            })}
                        </>}
                </Fragment>}
            </CustomPage>
        </IonPage>
    );
};

export default Pg_6_1;
